export const ArrayMax = (array : Array<number>) : number => {
    var max = Number.MIN_VALUE;
    for(let i = 0; i < array.length; i++)
        max = Math.max(max, array[i]);
    return max;
}

export const ArraySum = (array : Array<number>) : number => {
    var ret = 0
    for(let i = 0; i < array.length; i++)
        ret+= array[i];
    return ret;

}

export const ArrayMean = (array : Array<number>) : number => {
    return ArraySum(array)/ array.length;
}